import { css } from '@emotion/css'
import { fontSize } from '../../../styles'
import getThemeColors, { colors } from '../../../themes'

const styles = {
  wrapper: css({
    boxSizing: 'border-box',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    borderBottom: `1px solid ${colors.mystic}`,
    height: 35,
    fontSize: fontSize.small,
    display: 'flex',
    backgroundColor: colors.athensGray,

    '& > * + *': {
      borderLeft: `1px solid ${colors.mystic}`,
    },
  }),

  item: css({
    flex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: colors.jumbo,
    borderTop: '3px solid transparent',
    borderBottom: '3px solid transparent',

    '&:hover': {
      color: colors.oxfordBlue,
    },
  }),
}

export default styles

export const itemTheme = theme => {
  const themed = getThemeColors(theme)

  return css({
    color: colors.oxfordBlue,
    borderBottomColor: themed.base,
    backgroundColor: themed.light,
  })
}
